<template>
  <v-card>
    <v-navigation-drawer ref="mainNav" app bottom @input="$store.commit( 'setNavState', $event )" v-model="$store.state.navOpen">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">
            Registration
          </v-list-item-title>
          <v-list-item-subtitle>
            Campus Edu Registration Tool
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list
          dense
          nav
      >
        <v-list-item
            v-for="item in items"
            :key="item.title"
            :to="item.path"
            link
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </v-card>
</template>

<script>
export default {
  name: 'NavMain',
  props: {
    open: {
      type: Boolean,
      required: false,
    }
  },
  data () {
    return {
      items: [
        { title: 'Welcome', icon: 'mdi-home', path: '/welcome', },
        { title: 'New Applicants', icon: 'mdi-account-question', path: 'new-applicants', },
        { title: 'Archived Applicants', icon: 'mdi-archive', path: 'archived-applicants', },
        { title: 'Courses', icon: 'mdi-teach', path: 'courses',  },
      ],
    }
  },
  mounted() {
    this.$store.commit( 'setNavState', this.$refs.mainNav.isActive );
  },
}
</script>

<style scoped>

</style>
